import React from "react";
import { Modal } from "react-responsive-modal";
import {
  TitleProduct,
  SubTitleProduct,
  MiddleContainer,
  SubTitlePrice,
} from "../../components/modal/style/ConfirmationModalStyle";

import { Flex } from "../../styles/GlobalStyle";
import ButtonComponent from "../Button";
import LoadingIcon from "../LoadingIcon";
import Property from "../../model/property";
import { withTranslation } from "react-i18next";

const ConfirmationModal = ({
  showConfirmation,
  openCloseModal,
  onConfirm,
  total,
  loading,
  okDisabled,
  t,
}) => {
  const data = Property.getData();
  const autoText = data && data.store ? data.store.auto_reply_message : "";
  return (
    <Modal
      open={showConfirmation}
      onClose={() => {
        openCloseModal(!showConfirmation);
        const html = document.querySelector("html");
        html.style = "";
      }}
      showCloseIcon={false}
      center>
      <ModalContent
        onCancel={() => openCloseModal(!showConfirmation)}
        onConfirm={onConfirm}
        childrenTotal={total}
        children={t("CONTENT")}
        autoReplyText={autoText}
        okDisabled={okDisabled}
        t={t}
      />
      <LoadingIcon loadingState={loading} />
    </Modal>
  );
};

export default withTranslation()(ConfirmationModal);

function ModalContent({
  onConfirm,
  onCancel,
  children,
  childrenTotal,
  autoReplyText,
  okDisabled,
  t,
}) {
  const currencyCode = Property.getCurrencyCode();
  const preset = Property.getPreset();
  return (
    <MiddleContainer>
      <Flex
        flex={1}
        justifyContent={"center"}>
        <TitleProduct className={"modalTitle"}>
          {t("CONFIRM_ORDER")}
        </TitleProduct>
        <hr />
        <SubTitleProduct className={"modalSubtitle"}>
          {children}
        </SubTitleProduct>
        <SubTitlePrice
          className={"modalSubtitle"}
          app_home_menu_category={
            preset.app_home_menu_category
          }>
          {Intl.NumberFormat(currencyCode, {
            style: "currency",
            currency: currencyCode,
            currencyDisplay: "code",
          }).format(childrenTotal)}
        </SubTitlePrice>
        <SubTitleProduct className={"modalSubtitle"}>
          {autoReplyText}
        </SubTitleProduct>
        <Flex
          container
          flex={1}
          alignItems={"center"}
          justifyContent={"center"}>
          <ButtonComponent
            padding={"0.25em 0"}
            width={"80%"}
            label={t("CONFIRM")}
            backgroundColor={
              preset.app_home_color_primary
                ? preset.app_home_color_primary
                : "black"
            }
            color={preset.text_color}
            borderRadius={"30px"}
            onClick={onConfirm}
            disabled={okDisabled}
          />
        </Flex>
        <Flex
          container
          flex={1}
          alignItems={"center"}
          justifyContent={"center"}>
          <ButtonComponent
            padding={"0.25em 0"}
            width={"80%"}
            label={t("CANCEL")}
            backgroundColor={
              preset.app_home_color_primary
                ? preset.app_home_color_primary
                : "black"
            }
            color={preset.text_color}
            borderRadius={"30px"}
            onClick={onCancel}
          />
        </Flex>
      </Flex>
    </MiddleContainer>
  );
}
